// naming schema:
// first letter tile - top left: a, top right: b, bottom left: c, bottom right: f. 
// second letter size - small: s, medium: m, large: l.
export const flatlays = Object.freeze([
  'AS-BS-CS-F',
  'AS-BS-CM-F',
  'AS-BM-CS-F',
  'AS-BM-CM-F',
  'AL-BS-F',
  'AL-BM-F',
  'AL-BL-F',
  'AS-CS-F',
  'AS-CM-F',
])

const normalizeLayout = (layout) => (Array.isArray(layout) ? layout[0] : layout)
const tileOrder = ['a', 'b', 'c', 'f']

export const getFlatlayTileSizes = (layoutString) => {
  const layout = normalizeLayout(layoutString)
  if (!flatlays.includes(layout)) {
    return ['s', 's', 's', 's']
  }

  const sizeByTile = {
    a: 's',
    b: 's',
    c: 's',
    f: 's'
  }

  layout.split('-').forEach(group => {
    const tileChar = group[0] ? group[0].toLowerCase() : ''
    const tileKey = tileChar
    if (!tileOrder.includes(tileKey)) return

    const sizeChar = group[1] ? group[1].toLowerCase() : 's'
    sizeByTile[tileKey] = ['s', 'm', 'l'].includes(sizeChar) ? sizeChar : 's'
  })

  return tileOrder.map(tile => sizeByTile[tile])
}

export const getFlatlayUtilityClasses = (layoutString) => {
  const layout = normalizeLayout(layoutString)
  if (!flatlays.includes(layout)) {
    return { layoutClass: '', tileClasses: [], tilePresence: {} }
  }

  const sizes = getFlatlayTileSizes(layout)
  const tileClasses = sizes.map((size, index) => {
    return `tile-${tileOrder[index]}-${size}`
  })
  const tilePresence = tileOrder.reduce((acc, tile) => {
    acc[tile] = false
    return acc
  }, {})

  layout.split('-').forEach(group => {
    const tileChar = group[0] ? group[0].toLowerCase() : ''
    if (!tileOrder.includes(tileChar)) return
    tilePresence[tileChar] = true
  })

  return {
    layoutClass: `layout-${layout}`,
    tileClasses,
    tilePresence
  }
}
